/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { IReferenceNode } from '../IReferenceNode';
import { IVisitor } from '../../visitors/IVisitor';

/**
 * Models a schema.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExtensibleNode
 */
export class Schema extends ExtensibleNode implements IReferenceNode {
    public $ref : string;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitSchema(this);
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    constructor() {
        super();
        if(this.$ref===undefined) this.$ref = null;
    }
}
Schema["__class"] = "io.apicurio.datamodels.core.models.common.Schema";
Schema["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode"];




